import React from "react";
import styled from "styled-components";
import YouTube from "react-youtube";
import SoundCloudEmbed from "./SoundCloudEmbed";
import SpotifyEmbed from "./SpotifyEmbed";
import MediaContainer from "../../Containers/MediaContainer";
import Spinner from "react-bootstrap/Spinner";
import { MediaContext } from "../library/MediaContext";
import { isSoundCloudMediaUrl, isBandcampMediaUrl, isYouTubeMediaUrl, isSpotifyMediaUrl } from "../../utils/media";
import { getIdFromURL } from "../library/YouTubeHelpers";

const YouTubeWrapper = styled.section`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const TrackMedia = ({ track }) => {
  const { settings, setPlayingVideo } = React.useContext(MediaContext);
  const { media_id: mediaId, sc_url: mediaUrl } = track;
  const opts = { width: "100%", height: "100%" };

  function iframe(mediaUrl) {
    return {
      __html: `<iframe style="border: 0; width: 100%; height: 120px;" src="${mediaUrl}" seamless />`,
    };
  }

  return (
    <div className="totd-media media-youtube">
      <div>
        {isBandcampMediaUrl(track) && (
          <MediaContainer
            extUrl={mediaUrl}
            render={({ track, failure, loading }) => (
              <div>
                {loading && <Spinner animation="border" variant="dark" />}
                {!loading && !failure && <div dangerouslySetInnerHTML={iframe(track.embed_url)} />}
              </div>
            )}
          />
        )}
        {isYouTubeMediaUrl(track) ? (
          <YouTubeWrapper>
            <YouTube opts={opts} videoId={getIdFromURL(mediaUrl)} onPlay={(e) => setPlayingVideo(e)} />
          </YouTubeWrapper>
        ) : null}
        {isSoundCloudMediaUrl(track) ? <SoundCloudEmbed url={mediaUrl} /> : null}
        {isSpotifyMediaUrl(track) ? <SpotifyEmbed url={mediaUrl} /> : null}
      </div>
    </div>
  );
};

export default TrackMedia;
